// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__139TA","notes":"Notes_notes__1cAQq","note":"Notes_note__1np8w","markdown":"Notes_markdown__zMlhO"};